import { render, staticRenderFns } from "./ProjectConfiguration.vue?vue&type=template&id=be20fca4&scoped=true&"
import script from "./ProjectConfiguration.vue?vue&type=script&lang=js&"
export * from "./ProjectConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfiguration.vue?vue&type=style&index=0&id=be20fca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be20fca4",
  null
  
)

export default component.exports